import { render, staticRenderFns } from "./BookmarkNode.vue?vue&type=template&id=50b09490&scoped=true"
import script from "./BookmarkNode.vue?vue&type=script&lang=js"
export * from "./BookmarkNode.vue?vue&type=script&lang=js"
import style0 from "./BookmarkNode.vue?vue&type=style&index=0&id=50b09490&prod&scoped=true&lang=css"
import style1 from "./BookmarkNode.vue?vue&type=style&index=1&id=50b09490&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b09490",
  null
  
)

export default component.exports